import type {Annotation} from "@mytour/ui/form";
import {AnnotationSchema, ImageAnnotation} from "@mytour/ui/form";
import type {UseFormReturn} from "react-hook-form";
import z from "zod";

export const step4Schema = z.object({
  annotations: z.array(AnnotationSchema),
  imageData: z.string().optional(),
});

export type Step4Form = z.infer<typeof step4Schema>;

type Props = {
  hookForm: UseFormReturn<Step4Form>;
  disabled: boolean;
  closing: boolean;
};

export function Step4({hookForm, disabled, closing}: Props) {
  const annotations = hookForm.watch("annotations");
  return (
    <ImageAnnotation
      title="Annotations des antérieurs"
      imagePath="/images/podologie/ANT.png"
      values={annotations}
      onChange={handleChange}
      onUpdateImage={handleUpdateImage}
      disabled={disabled}
      closing={closing}
    />
  );

  function handleChange(annotations: Annotation[]) {
    hookForm.setValue("annotations", annotations);
  }

  function handleUpdateImage(imageData: string) {
    hookForm.setValue("imageData", imageData);
  }
}
